import { render, staticRenderFns } from "./Classification .vue?vue&type=template&id=51bc4267&scoped=true&"
import script from "./Classification .vue?vue&type=script&lang=js&"
export * from "./Classification .vue?vue&type=script&lang=js&"
import style0 from "./Classification .vue?vue&type=style&index=0&id=51bc4267&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc4267",
  null
  
)

export default component.exports